import React from "react";
import {
  Box,
  Grid,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  Radio,
  Button,
} from '@mui/material';
import { useParams } from 'react-router-dom';

const OrderDeliveryDetail = () => {
  const { deliveryId } = useParams();
  const data = [
        { item: 'Jeema Water 250', orderQty: 1, invQty: 1, rsp: 10, taxable: 10, tax: 0.5, net: 10.5 },
        { item: 'Jeema Water 250', orderQty: 1, invQty: 1, rsp: 10, taxable: 10, tax: 0.5, net: 10.5 },
        { item: 'Jeema Water 250', orderQty: 1, invQty: 1, rsp: 10, taxable: 10, tax: 0.5, net: 10.5 },
        { item: 'Jeema Water 250', orderQty: 1, invQty: 1, rsp: 10, taxable: 10, tax: 0.5, net: 10.5 },
        { item: 'Jeema Water 250', orderQty: 1, invQty: 1, rsp: 10, taxable: 10, tax: 0.5, net: 10.5 },
  ];

  const summary = {
    taxable: 50,
    tax: 2.5,
    net: 52.5,
  };

  return (
    <Box p={2}>
      <Box mb={2}>
        <Typography variant="h6" align="center">
          Delivery Details
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={6} sm={4}>
            <Typography variant="body2">Order No: 58000</Typography>
            <Typography variant="body2">Date: 29/11/2024</Typography>
            <Typography variant="body2">Time: 11.30 AM</Typography>
          </Grid>
          <Grid item xs={6} sm={4}>
            <Typography variant="body2">Order User: Ramesh</Typography>
            <Typography variant="body2">Picked: Ahamed</Typography>
            <Typography variant="body2">Mobile: 552387895</Typography>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Typography variant="body2">Car Plate No: w90731</Typography>
            <Typography variant="body2">Car Model: M17</Typography>
            <Typography variant="body2">Car Color: White</Typography>
          </Grid>
        </Grid>
      </Box>

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
                        <TableRow style={{ backgroundColor: '#c00', color: '#fff' }}>
                            <TableCell style={{ color: '#fff' }}>Item Name</TableCell>
                            <TableCell style={{ color: '#fff' }}>Order Qty</TableCell>
                            <TableCell style={{ color: '#fff' }}>Inv. Qty</TableCell>
                            <TableCell style={{ color: '#fff' }}>RSP</TableCell>
                            <TableCell style={{ color: '#fff' }}>Taxable Amount</TableCell>
                            <TableCell style={{ color: '#fff' }}>Tax Amount</TableCell>
                            <TableCell style={{ color: '#fff' }}>Net Amount</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((row, index) => (
              <TableRow key={index}>
                <TableCell>{row.item}</TableCell>
                <TableCell>{row.orderQty}</TableCell>
                <TableCell>{row.invQty}</TableCell>
                <TableCell>{row.rsp}</TableCell>
                <TableCell>{row.taxable}</TableCell>
                <TableCell>{row.tax}</TableCell>
                <TableCell>{row.net}</TableCell>
              </TableRow>
            ))}
            <TableRow>
              <TableCell colSpan={4} />
              <TableCell>{summary.taxable}</TableCell>
              <TableCell>{summary.tax}</TableCell>
              <TableCell>{summary.net}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>

      <Box mt={2}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <Typography variant="body2">Pay Mode</Typography>
            <Box>
              <Radio /> Cash <Radio /> Credit Card
            </Box>
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Narration"
              variant="outlined"
              size="small"
            />
          </Grid>
        </Grid>
      </Box>

      <Box mt={2} display="flex" justifyContent="space-between">
        <Button variant="contained" color="primary">
          Post
        </Button>
        <Button variant="contained" color="secondary">
          Print
        </Button>
      </Box>
    </Box>
  );
};

export default OrderDeliveryDetail;
